function DropdownFacet() { 
    const toggles = Array.from(document.querySelectorAll('.c-dropdown-facet__toggle')).filter(
        toggle => !toggle.closest('[data-vue-dropdown-facets]')
    );

    if (!toggles.length) return;

    closeAllDropdownFacets();
    toggles.forEach(setupDropdownFacet);
    setupDropdownFacetDismiss();
}

function setupDropdownFacet(toggle) {
    toggle.addEventListener('click', (event) => {
        event.preventDefault();

        const facet = toggle.closest('.c-dropdown-facet');
        const wasOpen = facet.classList.contains('c-dropdown-facet--open');

        closeAllDropdownFacets();

        if (!wasOpen) {
            facet.classList.add('c-dropdown-facet--open');
            toggle.setAttribute('aria-expanded', 'true');
        }
    });

    setupSelectedLabel(toggle);
}

// Radio facets are single-select, so the toggle shows the current selection
// rather than the static heading. Checkbox facets keep their heading.
function setupSelectedLabel(toggle) {
    const facet = toggle.closest('.c-dropdown-facet');
    if (!facet) return;

    const radios = Array.from(facet.querySelectorAll('input[type="radio"]'));
    if (!radios.length) return;

    const heading = getToggleTextNode(toggle).textContent.trim();

    facet.addEventListener('change', (event) => {
        const radio = event.target;
        if (radio.matches('input[type="radio"]') && radio.checked) {
            setToggleLabel(toggle, heading, getOptionLabel(radio));
        }
    });

    const checked = radios.find((radio) => radio.checked);
    if (checked) setToggleLabel(toggle, heading, getOptionLabel(checked));
}

function getOptionLabel(radio) {
    const label = radio.labels && radio.labels[0];
    return label ? label.textContent.trim() : radio.value;
}

function setToggleLabel(toggle, heading, selected) {
    if (!selected) return;

    getToggleTextNode(toggle).textContent = selected;

    // The visible text no longer names the facet, so keep the heading in the
    // accessible name. It still contains the visible text, so Label in Name holds.
    toggle.setAttribute('aria-label', heading ? `${heading}: ${selected}` : selected);
}

// The heading is a bare text node sitting alongside the chevron icon, so replace
// that node rather than the button's textContent, which would drop the icon.
function getToggleTextNode(toggle) {
    const existing = Array.from(toggle.childNodes).find(
        (node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== ''
    );
    if (existing) return existing;

    const created = document.createTextNode('');
    toggle.insertBefore(created, toggle.firstChild);
    return created;
}

function setupDropdownFacetDismiss() {
    document.addEventListener('click', (event) => {
        if (event.target.closest('.c-dropdown-facet')) return;
        closeAllDropdownFacets();
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeAllDropdownFacets();
    });
}

function closeAllDropdownFacets() {
    Array.from(document.querySelectorAll('.c-dropdown-facet--open')).filter(
            facet => !facet.closest('[data-vue-dropdown-facets]')).forEach((facet) => {
        facet.classList.remove('c-dropdown-facet--open');
        const toggle = facet.querySelector('.c-dropdown-facet__toggle');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
}

export default DropdownFacet;